import "./SubscriptionInfo.scss";

import { useEffect } from "react";
import { Button, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";

import { AzureIcon } from "../../../../components/icons";
import { useCheckoutLink } from "../../../../hooks/reactQueryHooks/useBilling";

interface SubscriptionInfoProps {
  subscriptionType: string;
  isStripe: boolean;
  organization: string;
}

const SubscriptionInfo: React.FC<SubscriptionInfoProps> = ({
  subscriptionType,
  isStripe,
  organization,
}) => {
  const {
    data: checkoutLink,
    isFetching,
    isLoading,
    refetch,
  } = useCheckoutLink(organization, window.location.href);

  const handleChargeClick = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    refetch();
  };

  useEffect(() => {
    if (checkoutLink) {
      window.location.href = checkoutLink.url;
    }
  }, [checkoutLink]);

  return (
    <>
      {isStripe ? (
        <>
          <p className="subscription-info-descr">
            Your credit balance will decrease as you use the CogCache Proxy API.
            Visit the <Link to="/organization/usage">Usage</Link> page for a
            detailed breakdown of your consumption.
          </p>
          <Button
            variant="primary"
            onClick={handleChargeClick}
            disabled={isLoading || isFetching}
          >
            Add to credit balance
            {(isLoading || isFetching) && (
              <Spinner
                className="ms-2"
                size="sm"
                animation="border"
                data-testid="subscription-info-spinner"
              />
            )}
          </Button>
        </>
      ) : (
        <>
          <h6 className="subscription-info-title">
            <AzureIcon />
            Azure Marketplace subscription
          </h6>
          {subscriptionType === "Ptu" ? (
            <p className="subscription-info-descr">
              You are on a subscription managed by the Azure Marketplace. All
              the payments are being processed by Microsoft Azure. Your costs
              will increase as you use the CogCache Proxy API. Visit the{" "}
              <Link to="/organization/usage">Usage</Link> page for a detailed
              breakdown of your consumption.
            </p>
          ) : (
            <p className="subscription-info-descr">
              You are on a subscription managed by the Azure Marketplace. All
              the payments are being processed by Microsoft Azure. We continue
              caching your requests after the plan limit is reached, but you
              will be additionally charged for each cache item / month.
            </p>
          )}
        </>
      )}
    </>
  );
};

export { SubscriptionInfo };
